<template>
    <div class="content-info">
        <img class="content-info-img" src="@/assets/img/merchant/geometric.png" alt="">
        <div class="content-info-itens">
            <img src="@/assets/img/merchant/bg-info.png" alt="" class="container pr-0 pl-0">
            <div class="content-info-itens-cards container row">
                <div class="row">
                    <div class="content-info-itens-cards-item col-md-12">
                        <div class="content-info-itens-cards-item-title">
                            <h3 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Com utilizar o freebee®</h3>
                        </div>
                    </div>
                </div>
                <div class="row cards">
                    <div class="content-info-itens-cards-item col-md-4">
                        <div class="content-info-itens-cards-item-card">
                            <h1 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Passo 1</h1>
                            <img src="@/assets/img/client/step1.png" alt="">
                            <h2 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Aderir ao freebee®</h2>
                            <p class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Na loja, dê o seu número de telemóvel no momento da compra e será criado um pré-registo.</p>
                        </div>
                    </div>
                    <div class="content-info-itens-cards-item col-md-4">
                        <div class="content-info-itens-cards-item-card">
                            <h1 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Passo 2</h1>
                            <img src="@/assets/img/client/step2.png" alt="">
                            <h2 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Identifique-se com o seu nº de telemóvel</h2>
                            <p class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Quando for a uma loja aderente identifique-se com o seu número de telemóvel</p>
                        </div>
                    </div>
                    <div class="content-info-itens-cards-item col-md-4">
                        <div class="content-info-itens-cards-item-card">
                            <h1 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Passo 3</h1>
                            <img src="@/assets/img/client/step3.png" alt="">
                            <h2 class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Já começou a poupar!</h2>
                            <p class="v-content-client-info" v-contentClientInfo="{ section: 'Steps', removeHtml: true }">Sempre que visitar uma loja freebee® vai acumular descontos e vantagens!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import store from "@/store";

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
  name: "Banner",
  data() {
    return {};
  },
  methods: {
    updateDirectives() {
      const allElements = document.querySelectorAll('.v-content-client-info');
      allContents.splice(0, allContents.length); // clear the contents array
      allElements.forEach((el) => {
          const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
      });
    },
  },
  created() {
      this.updateDirectives();
  },
  mounted() {},
  directives: {
      contentClientInfo: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-client-info');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-client-info');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
};
</script>

<style lang="scss" scoped>
.content-info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 200px 0;
  position: relative;
  overflow: hidden;
  @media screen and (max-width: 1500px) {
    padding: 150px 0;
  }
  @media screen and (max-width: 1300px) {
    padding: 100px 0;
  }
  @media screen and (max-width: 991px) {
    padding: 50px 0;
  }
  &-img {
    position: absolute;
    top: 0px;
    left: -66px;
    height: auto;
    z-index: 0;
    @media screen and (max-width: 1500px) {
      width: 500px;
      right: 0px;
    }
    @media screen and (max-width: 1300px) {
      width: 400px;
      right: -50px;
    }
    @media screen and (max-width: 991px) {
      display: none;
    }
  }

  &-itens {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--white);
    @media screen and (max-width: 991px) {
        height: 1625px;
        width: 100%;
    }
    img {
      width: 100%;
      height: auto;
      border-radius: 55px;
      z-index: 1;
    }
    &-cards {
      position: absolute;
      top: 0;
      bottom: 0;
      background-color: #e84d0f95;
      border-radius: 55px;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      gap: 50px;
      padding:50px;
      height: auto;
      @media screen and (max-width: 1500px) {
        gap: 20px;
      }
      @media screen and (max-width: 991px) {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        align-content: center;
        gap: 15px;
        padding: 0 50px;
        border-radius: 20px;
        background-image: url('~@/assets/img/merchant/bg-info.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 20px;
      }
      .cards{
        display: flex;
        align-items: flex-start;
        @media screen and (max-width: 991px) {
          flex-direction: column;
          align-items: center;
          gap: 30px;          
        }
      }
      &-item {
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 991px) {
          flex-direction: column;
          align-items: center;
          width: 100%;
          max-width: 100%;
        }
        &-title{
            display: flex;
            align-items: center;
            flex-direction: column;
            color: var(--white);
            text-align: center;
            h3{
                max-width: 900px;
                font-family: 'Font Bold';
                font-size: 45px;
                line-height: 60px;
                @media screen and (max-width: 1500px) {
                    font-size: 35px;
                    line-height: 45px;
                }
                @media screen and (max-width: 991px) {
                    font-size: 26px;
                    line-height: 36px;
                    margin-bottom: 20px;
                }
            }
        }
        &-card{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column; 
            gap: 30px;
            @media screen and (max-width: 1100px) {
              gap: 15px;
            }
            @media screen and (max-width: 991px) {
                flex-direction: column;
                align-items:center;
                gap: 20px;
            }
            h1{
                font-family: 'Font Bold';
                font-size: 35px;
                line-height: 45px;
                color: var(--white);
                @media screen and (max-width: 1500px) {
                    font-size: 30px;
                    line-height: 40px;
                }
                @media screen and (max-width: 991px) {
                    font-size: 26px;
                    line-height: 36px;
                }
            }
            h2{
                font-family: 'Font Bold';
                font-size: 35px;
                line-height: 45px;
                color: var(--white);
                height: 80px;
                @media screen and (max-width: 1500px) {
                    font-size: 30px;
                    line-height: 40px;
                    height: 60px;
                }
                @media screen and (max-width: 991px) {
                    font-size: 16px;
                    line-height: 26px;
                    height: auto;
                }
            }
            img{
                width: 380px;
                height: auto;
                margin-right: 30px;
                max-width: 100%;
                @media screen and (max-width: 1500px) {
                    width: 230px;
                    margin-right: 0px;
                    margin-bottom: 20px;
                }
                @media screen and (max-width: 991px) {
                    width: 246px;
                    margin-right: 0px;
                    margin-bottom: 20px;
                }
            }
            p{
                font-family: 'Font Regular';
                font-size: 24px;
                line-height: 34px;
                color: var(--white);
                @media screen and (max-width: 1500px) {
                    font-size: 20px;
                    line-height: 35px;
                }
                @media screen and (max-width: 991px) {
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                }
            };
        }
      }
    }
  }
}
</style>